import { AttachmentIcon } from 'assets/icons/AttachmentIcon'
import { Badge } from 'components/Badge/Badge'
import { Card, CardBody } from 'components/Card/Card'
import React from 'react'
import { colors, ColorVariant, Flex, Icon } from 'styling/GlobalStyles'
import { BigText, MediumText, SmallText } from 'styling/TypographyV2'
import { ProcurementPurchaseRequestQuoteResponse } from 'types/procurement'

export const SupplierItem = ({
  supplier,
  isWinningOffer = false,
  setSelectedOffer,
}: {
  supplier: ProcurementPurchaseRequestQuoteResponse
  isWinningOffer?: boolean
  setSelectedOffer?: (offer: ProcurementPurchaseRequestQuoteResponse) => void
}) => {
  return (
    <Card borderLeft={isWinningOffer ? colors.green : '#AF52DE'}>
      <CardBody>
        <Flex gap='0.5rem' center mb='6'>
          <MediumText
            bold
            colorVariant={supplier.supplier ? ColorVariant.PRIMARY : ColorVariant.BASE}
          >
            {supplier.supplier ? supplier.supplier.name : supplier.supplierName}
          </MediumText>
          {isWinningOffer && <Badge hexColor={colors.green}>Winning offer</Badge>}
          {setSelectedOffer && (
            <SmallText
              hoverUnderline
              pointer
              colorVariant={ColorVariant.GREEN}
              onClick={() => setSelectedOffer?.(supplier)}
            >
              Select this supplier
            </SmallText>
          )}
        </Flex>
        <BigText
          bold
          colorVariant={isWinningOffer ? ColorVariant.GREEN : ColorVariant.BASE}
          mb='4px'
        >
          {supplier.totalPrice ? `${supplier.totalPrice} ` : 'N/A '}
          {supplier.currency}
        </BigText>
        <Flex gap='0.5rem'>
          <MediumText colorVariant={ColorVariant.SECONDARY}>
            {supplier.deliveryTimeInDays} days delivery
          </MediumText>
          {supplier.quoteUrl && (
            <MediumText colorVariant={ColorVariant.PRIMARY} hoverUnderline pointer>
              <a href={supplier.quoteUrl} target='_blank' rel='noopener noreferrer'>
                <Flex gap='0.25rem' center>
                  <Icon size='0.75rem'>
                    <AttachmentIcon />
                  </Icon>
                  Quotation attached
                </Flex>
              </a>
            </MediumText>
          )}
        </Flex>
      </CardBody>
    </Card>
  )
}
